/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import axios from 'axios';

import { ROOT_URL_V2, getCSRFToken } from '../../../../config';
import PopupHeader from '../../../common/PopupHeader';
import { AgentShiftForm } from '../AgentShiftForm';
import actions from '../../../../actions';
import { fetchClientAddressList } from '../../../../actions/ClientData';
import { getErrorMessages } from '../../../../utils';
import history from '../../../../history';
import { fetchSeries } from '../../../../actions/Series';

class CreateShiftContainer extends Component {
    state = {
        isLoading: false,
        errorMessage: null,
    };

    setErrorMessage = errorMsg => this.setState({ errorMessage: errorMsg });

    handleFormSubmit = formValues => {
        this.setState({ isLoading: true });
        // eslint-disable-next-line @typescript-eslint/no-this-alias

        return axios({
            method: 'post',
            url: `${ROOT_URL_V2}jobs/`,
            data: formValues,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                const queryParams = new URLSearchParams();

                const jobSeries = Array.isArray(response?.data?.content)
                    ? response?.data?.content.find(
                        job => job.series_reference_number,
                      )
                    : response?.data?.content?.series_reference_number;

                let referenceNumber;

                if (jobSeries) {
                    referenceNumber = response.data.content.map(job => job.reference_number).join(', ');
                    queryParams.set('search', jobSeries.series_reference_number);
                    queryParams.set('getall', '1');
                    history.push({
                        pathname: '/series/list',
                        search: queryParams.toString(),
                    });
                    this.props.loadSeries(queryParams);
                } else {
                    referenceNumber = response.data.content.reference_number;
                    queryParams.set('search', referenceNumber);
                    queryParams.set('getall', '1');
                    history.push({
                        pathname: '/jobs/list',
                        search: queryParams.toString(),
                    });
                    this.props.load(queryParams);
                }

                this.props.notification.success(
                    'Success',
                    `${referenceNumber} successfully created`,
                );

            })
            .catch(error => {
                this.setState({ isLoading: false });
                this.setErrorMessage(getErrorMessages(error));
            });
    };

    onDismiss = () => {
        this.props.fetchClientAddressList([]);
        const currentUrlParams = new URLSearchParams(history.location.search);

        history.push({
            pathname: '/jobs/list',
            search: currentUrlParams.toString(),
        });
    };

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        const selectedDate = moment(currentUrlParams.get('after'));
        const createAfter = moment(currentUrlParams.get('createafter'));
        const minStart = moment(this.props.minStart);

        const job = {
            service: currentUrlParams.get('service') || 'driver',
            vehicle_type: currentUrlParams.get('vehicle_type') || 2,
            number_of_freelancers: 1,
            start_time: createAfter.isValid()
                ? createAfter.format('HH:mm')
                : minStart.format('HH:mm'),
            date: selectedDate.isValid()
                ? moment(selectedDate).format('YYYY-MM-DD')
                : moment(Date.now()).add(3, 'hours').format('YYYY-MM-DD'),
            duration: 4,
        };

        return (
            <div className="create-shift">
                <PopupHeader title="&nbsp;" onDismiss={this.onDismiss} />
                <AgentShiftForm
                    history={history}
                    defaultJob={job}
                    handleFormSubmit={this.handleFormSubmit}
                    mode="create"
                    isLoading={this.state.isLoading}
                    errorMessage={this.state.errorMessage}
                    setErrorMessage={this.setErrorMessage}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    minStart: state.requestData.minStart,
});

const mapDispatchToProps = dispatch => ({
    load: searchParams => dispatch(actions.loadShifts(searchParams)),
    loadSeries: searchParams => dispatch(fetchSeries(searchParams)),
    fetchClientAddressList,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CreateShiftContainer);
